module.exports = __webpack_public_path__ + "img/default-img2.3ea110f0.jpg";